module.exports = __webpack_public_path__ + "static/img/home_tractocamiones.f7eb29c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_tractocamiones.png
// module id = 90
// module chunks = 0